import React from 'react'

import { ShoppingBasketRemove, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

function EmptyCart({ locale }) {
  return (
    <div
      id="cart-box-content"
      className="cart-popover-content"
    >
      <div className="row justify-content-center">
        <Icon
          svgComponent={ShoppingBasketRemove}
          color="dark"
        />
      </div>

      <h4 className="cgt-legacy-heading-h5 u-text-center cgt-mb-4">
        {i18n.t('navigation.cart_widget.subtitle', {
          ns: 'rails',
          lng: locale,
        })}
      </h4>

      <p className="cgt-legacy-text-tiny u-text-center">
        {i18n.t('navigation.cart_widget.text', {
          ns: 'rails',
          lng: locale,
        })}
      </p>
    </div>
  )
}

EmptyCart.propTypes = {
  locale: string.isRequired,
}

export default EmptyCart
